import {ComplianceManagerApi} from "../compliance-manager";
import {ComplianceManagerTab} from "../state";
import {Tabs} from "antd";
import {IcanTab, IsnTab, VeriflytTab} from "./tab-content";
import React from "react";
import './tabs.style.less';
import ComplianceStatusButton from "../../compliance-status-button";
import OverallTab from "./tab-content/overall-tab";
import {ProviderType} from "../../../../__generated__/graphql/types";

/**
 * Renders tabs for each compliance source.
 */
export default function ComplianceManagerTabs(props: { api: ComplianceManagerApi }){
    const { state, setTab, availableTabs, paxContext } = props.api;
    const currTab = state.currentTab;

    const tabPanes = [];

    function renderPane(tab: ComplianceManagerTab){

        let paneContent: React.ReactNode = "Not available";
        let tabText: React.ReactNode = tab?.toString() || 'Unknown';

        switch (tab){
            case ComplianceManagerTab.OVERALL:
                paneContent = <OverallTab api={props.api} />
                tabText = <span>
                    OVERALL{' '}
                    <ComplianceStatusButton
                        style={{ marginLeft: 6, fontSize: '0.7rem' }}
                        pax={paxContext}
                        size="small"
                        disabled
                        showSourcesTooltip={false}
                    />
                </span>;
                break;
            case ComplianceManagerTab.VERIFLYT:
                paneContent = <VeriflytTab api={props.api} />
                tabText = <span>
                    VERIFLYT{' '}
                    <ComplianceStatusButton
                        style={{ marginLeft: 6, fontSize: '0.7rem' }}
                        pax={paxContext}
                        size="small"
                        selectedProvider={ProviderType.VERIFLYT}
                        disabled
                        showSourcesTooltip={false}
                    />
                </span>;
                break;
            case ComplianceManagerTab.ISN:
                paneContent = <IsnTab api={props.api} />
                tabText = <span>
                    ISN{' '}
                    <ComplianceStatusButton
                        style={{ marginLeft: 6, fontSize: '0.7rem' }}
                        pax={paxContext}
                        size="small"
                        selectedProvider={ProviderType.ISN}
                        disabled
                        showSourcesTooltip={false}
                    />
                </span>;
                break;
            case ComplianceManagerTab.ICAN:
                paneContent = <IcanTab api={props.api} />
                tabText = <span>
                    ICAN{' '}
                    <ComplianceStatusButton
                        style={{ marginLeft: 6, fontSize: '0.7rem' }}
                        pax={paxContext}
                        size="small"
                        selectedProvider={ProviderType.ICAN}
                        disabled
                        showSourcesTooltip={false}
                    />
                </span>;
                break;
        }

        return (
            <Tabs.TabPane key={tab} tab={tabText} style={{ padding: 24, paddingTop: 0 }}>
                {paneContent}
            </Tabs.TabPane>
        )
    }

    for (let tab of availableTabs) {
        tabPanes.push(renderPane(tab));
    }

    return (
        <Tabs
            activeKey={currTab}
            onChange={(tab) => setTab(tab as ComplianceManagerTab)}
            type="card"
            tabBarStyle={{
                margin: 0
            }}
            className="mc-compliance-manager-tabs"
        >
            {tabPanes}
        </Tabs>
    )
}